import type { LoadableComponent } from '@loadable/component'

/**
 * Returns the actual component from a possibly loadable component.
 * If the component is not loadable, it is returned as-is.
 */
export async function getLoadableComponent(Component: React.ComponentType) {
  const loadComponent = (Component as LoadableComponent<unknown>).load
  if (typeof loadComponent === 'function') {
    Component = await loadComponent()

    // Loadable components have the signature { default: Component }
    Component = (Component as unknown as { default: React.ComponentType }).default
  }

  return Component
}
